import { render, staticRenderFns } from "./RelatorioGeracaoListView.vue?vue&type=template&id=d9116580"
import script from "./RelatorioGeracaoListView.vue?vue&type=script&lang=ts"
export * from "./RelatorioGeracaoListView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports